import Icon from '@ui/components/Icon/Icon';

import './ScimNonOwnerCard.scss';

const ScimNonOwnerCard = () => (
	<div className="ScimNonOwnerCard">
		<div className="ScimNonOwnerCard-header">
			<span className="ScimNonOwnerCard-title">SCIM Provisioning</span>
			<p className="ScimNonOwnerCard-description">
				Connect your identity provider to automatically manage VeryBusy accounts when employees join,
				change roles, or leave. Copy your SCIM key and endpoint to your identity provider.{' '}
				{/* Temporal: "Coming soon!" en lugar de "How to set up SCIM →" */}
				{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
				<a className="ScimNonOwnerCard-link" href="#">Coming soon!</a>
			</p>
		</div>

		<div className="ScimNonOwnerCard-banner">
			<Icon icon="info" size={16} className="ScimNonOwnerCard-banner-icon" />
			<span className="ScimNonOwnerCard-banner-text">
				Contact your workspace owner to request Admin access
			</span>
		</div>
	</div>
);

export default ScimNonOwnerCard;
